import url from 'url';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { BaseLoader } from '../Loader';
import hasNeverSubscribedOnWeb from '../../utils/subscription/hasNeverSubscribedOnWeb';
import getLoginRedirect from '../../utils/auth/getLoginRedirect';

import { SUBSCRIBE_PATH } from '../../constants/paths';
import PaymentInformationLoader from './PaymentInformationLoader';

class PaymentInformationRoute extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    me: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    const redirectRoute = this.determineRoute();

    if (redirectRoute) {
      this.props.history.replace(redirectRoute);
    }
    this.state = { redirectRoute };
  }

  determineRoute() {
    const { auth, me, location } = this.props;

    const loginRedirect = getLoginRedirect(auth, location);

    if (loginRedirect) {
      return url.format(loginRedirect);
    }
    if (hasNeverSubscribedOnWeb(me)) {
      return SUBSCRIBE_PATH;
    }

    return null;
  }

  render() {
    return this.state.redirectRoute ? (
      <BaseLoader />
    ) : (
      <PaymentInformationLoader {...this.props} />
    );
  }
}

function mapStateToProps(state) {
  const { auth, me } = state;
  return { auth, me };
}

export default connect(mapStateToProps)(PaymentInformationRoute);
